<template>
  <div class="section" id="carousel">
    <div class="container">
      <div class="title">
        <h4>Past Workshops</h4>
      </div>
      <div class="row justify-content-center">
        <div class="col-8">
          <el-carousel height="500px">
            <el-carousel-item>
              <img class="d-block" src="img/landing/sideImage (4).jpeg" alt="First slide" />
              <div class="carousel-caption d-none d-md-block">
                <h5>LOA Advanced, Workshop</h5>
              </div>
            </el-carousel-item>
            <el-carousel-item>
              <img class="d-block" src="img/landing/sideImage (5).jpeg" alt="Second slide" />
              <div class="carousel-caption d-none d-md-block">
                <h5>LOA Money, Workshop</h5>
              </div>
            </el-carousel-item>
            <el-carousel-item>
              <img class="d-block" src="img/landing/sideImage (6).jpeg" alt="Third slide" />
              <div class="carousel-caption d-none d-md-block">
                <h5>LOA Basic, Workshop</h5>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Carousel, CarouselItem } from 'element-ui';

export default {
  components: {
    [Carousel.name]: Carousel,
    [CarouselItem.name]: CarouselItem
  }
};
</script>
<style></style>
